import TrackerStatusDropdownSelection from 'app/models/tracker_status_dropdown_selection';

const PARAM_KEY = 'status';
const QUERY_PARAMS = {
  '': undefined,
  in_transit: { [PARAM_KEY]: ['pre_transit', 'unknown', 'in_transit'] },
  out_for_delivery: { [PARAM_KEY]: ['out_for_delivery'] },
  delivered: { [PARAM_KEY]: ['delivered', 'available_for_pickup'] },
  return_to_sender: { [PARAM_KEY]: ['return_to_sender'] },
};

export default TrackerStatusDropdownSelection.extend({
  initialize(options) {
    TrackerStatusDropdownSelection.prototype.initialize.apply(this, options);
    this.choices = [
      { option: '', readable: 'All Statuses' },
      { option: 'in_transit', readable: 'In Transit' },
      { option: 'out_for_delivery', readable: 'Out for Delivery' },
      { option: 'delivered', readable: 'Delivered' },
      { option: 'return_to_sender', readable: 'Return to Sender' },
    ];
  },

  getParams() {
    return QUERY_PARAMS[this.get('currentChoice').option];
  },
});



// WEBPACK FOOTER //
// ./app/models/delayed_tracker_status_dropdown_selection.js